'use strict';

//import './app-transition.scss';

import AppTransition from './app-transition';

export default AppTransition;
